import { putShopIntroduction } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  UpdateCurationInfoServiceRequest,
  UpdateCurationInfoServiceResponse,
} from './curation-info.dto';
import {
  UpdateCurationInfoServiceRequestSchema,
  UpdateCurationInfoServiceResponseSchema,
} from './curation-info.dto';

export const updateCurationInfoService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(UpdateCurationInfoServiceRequestSchema),
    async (
      request: UpdateCurationInfoServiceRequest,
    ): Promise<UpdateCurationInfoServiceResponse> => {
      const { data, meta } = await putShopIntroduction({
        description: request.description,
      });

      if (meta?.result === 'FAIL') {
        throw new Error(meta?.message ?? '서버에서 에러가 발생했습니다.');
      }

      return {
        description: data.description,
        curatorId: data.curatorId,
      };
    },
    validateServiceResponse(UpdateCurationInfoServiceResponseSchema),
  ),
);
